function parenthesizeBookName(bookName: string) {
  return `(${bookName})`;
}

export { parenthesizeBookName };
